import React from "react"
import { pageStatusEnum } from "utils"

// prettier-ignore
export type PageAction = { type: "LOADING" } | { type: "SUCCESS" } | { type: "ERROR" }
export type PageDispatch = (action: PageAction) => void

const pageReducer = (state: any, action: PageAction) => {
	switch (action.type) {
		case "LOADING": {
			return {
				status: pageStatusEnum.loading,
			}
		}
		case "SUCCESS": {
			return {
				status: pageStatusEnum.complete,
			}
		}
		case "ERROR": {
			return {
				status: pageStatusEnum.errored,
			}
		}
	}
}

function usePageReducer() {
	const [{ status }, dispatchPage] = React.useReducer(pageReducer, {
		status: pageStatusEnum.loading,
	})

	const isLoading = status === pageStatusEnum.loading
	const isComplete = status === pageStatusEnum.complete
	const isErrored = status === pageStatusEnum.errored

	const dispatchPageIsLoading = () => dispatchPage({ type: "LOADING" })
	const dispatchPageIsComplete = () => dispatchPage({ type: "SUCCESS" })
	const dispatchPageIsErrored = () => dispatchPage({ type: "ERROR" })

	return {
		dispatchPageIsLoading,
		dispatchPageIsComplete,
		dispatchPageIsErrored,
		isLoading,
		isComplete,
		isErrored,
	}
}

export { usePageReducer }
